module.exports = __webpack_public_path__ + "src/img/artist/artistpage2.svg?95108985582c05413edc39b2254d5e07";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage2.svg
// module id = 120
// module chunks = 0